import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import cn from 'classnames';

import Icon from 'Components/Icon';
import GroupByBtn from './components/GroupByBtn';
import ExportBtn from './components/ExportBtn';
import DropdownMenu from 'Components/Admin/DropdownMenu';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';
import ToggleButton from 'Components/ToggleButton/ToggleButton';
import { ALL_CURRENCIES } from '../../constants/constants';
import MoreSVG from 'Components/Admin/assets/MoreSVG.js';
import useWindowDimensions from 'Shared/hooks/useWindowDimensions';
import strToBool from 'Shared/util/strToBool';
import { MOBILE_WIDTH_BREAKPOINT, SHOW_ON_DEV } from '../../constants/constants';

const optionCurrency = ['$ (USD)', '€ (EUR)', '₴ (UAH)', '£ (GBP)', 'CHF (CHF)', '$ (AUD)', ALL_CURRENCIES];
const optionPeriod = ['Months', 'Quarters', 'Years'];

const getOption = (options, searchParams, paramName) => {
  if (searchParams.has(paramName)) {
    const option = options.find((element) => element.toLowerCase().includes(searchParams.get(paramName).toLowerCase()));
    return option ?? options[0];
  }
  return options[0];
};

function Dashboard({ showPercent, handlePerception, getPeriod, getCurrency, localStorageItem }) {
  const history = useHistory();
  const preserveHistorySearch = localStorage.getItem(localStorageItem);
  const searchParams = new URLSearchParams(history.location.search || preserveHistorySearch);

  const initCurrency = getOption(optionCurrency, searchParams, 'currency');
  const initPeriod = getOption(optionPeriod, searchParams, 'period');
  const initByProject = searchParams.get('by-project');

  const [currency, setCurrency] = useState(initCurrency);
  const [period, setPeriod] = useState(initPeriod);
  const [isProjectSelected, setIsProjectSelected] = useState(strToBool(initByProject));
  const { width } = useWindowDimensions();

  const renderGroupByCurrency = () => (
    <GroupByBtn
      options={optionCurrency}
      select={currency}
      setSelect={(item) => {
        setCurrency(item);
        if (item === ALL_CURRENCIES) {
          setIsProjectSelected(false);
          getCurrency({ currencyLabel: item, projectSelected: false });
        } else {
          getCurrency({ currencyLabel: item, projectSelected: isProjectSelected });
        }
      }}
    />
  );

  const renderGroupByPeriod = () => (
    <GroupByBtn
      options={optionPeriod}
      select={period}
      setSelect={(item) => {
        setPeriod(item);
        getPeriod(item);
      }}
    />
  );

  const renderToggleComponent = () => (
    <div className="by_project">
      <span>By project</span>
      <ToggleButton
        onToggleChange={(boolean) => {
          setIsProjectSelected(boolean);
          setCurrency(currency === ALL_CURRENCIES ? optionCurrency[0] : currency);
          getCurrency({
            currencyLabel: currency === ALL_CURRENCIES ? optionCurrency[0] : currency,
            projectSelected: boolean,
          });
        }}
        toggleStatus={isProjectSelected}
        inversion={true}
        extractToggle={true}
        id={'by-project'}
      />
    </div>
  );

  // TO DO: remove SHOW_ON_DEV when actions will be implemented
  return (
    <div className="dashboard">
      <div className="dashboard__block block">
        {width > MOBILE_WIDTH_BREAKPOINT ? (
          <>
            {renderGroupByCurrency()}
            {renderGroupByPeriod()}
            {renderToggleComponent()}
          </>
        ) : (
          <div className="dashboard__dropdown-menu-wrapper">
            <DropdownMenu
              binding="bottom"
              triggerButtonRender={(isOpen) => (
                <div className="dashboard__dropdown-menu-wrapper__grouping-btn">
                  <span>Groupings</span>
                  <TriangleIcon direction={isOpen ? 'up' : 'down'} />
                </div>
              )}
            >
              {renderGroupByCurrency()}
              {renderGroupByPeriod()}
              {renderToggleComponent()}
            </DropdownMenu>
          </div>
        )}
      </div>
      <div className="dashboard__block control-block">
        {width > MOBILE_WIDTH_BREAKPOINT ? (
          SHOW_ON_DEV && (
            <>
              <button
                className={cn('dashboard__block__button ', { 'active-button': showPercent })}
                onClick={handlePerception}
              >
                <Icon className="icon-arrows-updown" />
              </button>
              <button className="dashboard__block__button">
                <Icon className="icon-print" />
              </button>
              <ExportBtn />
            </>
          )
        ) : (
          <div className="dashboard__more-block">
            {SHOW_ON_DEV && (
              <DropdownMenu
                binding="bottom"
                triggerButtonRender={() => (
                  <div className="dashboard__more-block__more-btn">
                    <MoreSVG />
                  </div>
                )}
              >
                <li onClick={handlePerception} className="li-content-wrapper">
                  Indicators
                </li>
                <li className="li-content-wrapper">Print</li>
                <li>
                  <div className="dropdown-menu-export">
                    <DropdownMenu
                      binding="bottom"
                      triggerButtonRender={(isOpen) => (
                        <div className="btn-content-wrapper">
                          <span>Export</span> <TriangleIcon direction={isOpen ? 'up' : 'down'} />
                        </div>
                      )}
                    >
                      <li className="li-content-wrapper">PDF</li>
                      <li className="li-content-wrapper">DOCX</li>
                      <li className="li-content-wrapper">TIFF</li>
                      <li className="li-content-wrapper">TIFF</li>
                      <li className="li-content-wrapper">HTML</li>
                    </DropdownMenu>
                  </div>
                </li>
              </DropdownMenu>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
